import React, {useEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import {Layout, Menu} from 'antd';
import {MenuKeysWithDynamicChildren, superUserMenu, userMenu} from '../../constants/menus';
import SidebarHeader from './Header';
import './style.css';
import {compose} from 'redux';
import {getFilteredTree} from "../../utils/tree";
import {isClassificationsServer, isPageVisible, propertyIsDefined} from "../utils";
import _ from 'lodash';
import {fetchDynamicEntry, setOpenMenuKeys} from '../../reducers/app/actions';
import SidebarSubMenu from "./SidebarSubMenu";


const mapStateToProps = state => {
    const chosenEndpoint = !state.app.endpointId ? null : (state.config.nodes || []).find(node => node.general.id === state.app.endpointId);
    return {
        appLanguage: state.app.language,
        nodeId: state.app.endpointId,
        nodes: state.config.nodes,
        isSidebarCollapsed: state.app.isSidebarCollapsed,
        openMenuKeys: state.app.openMenuKeys,
        anonymousPages: state.config.userInterface.anonymousPages,
        permissions: state.app.user.permissions,
        username: state.app.user.username,
        dynamicSidebarChildren: state.app.dynamicSidebarChildren,
        token: state.app.user.token,
        chosenEndpoint
    }
};

const mapDispatchToProps = dispatch => ({
    onSetOpenMenuKeys: openMenuKeys => dispatch(setOpenMenuKeys(openMenuKeys)),
    onFetchDynamicEntry: ({url, parentPath, childPath}) => dispatch(fetchDynamicEntry(url, parentPath, childPath))
});

const SIDEBAR_TITLE_HEIGHT = 64;

const Sidebar = ({
                     isSidebarCollapsed,
                     location,
                     anonymousPages,
                     t,
                     permissions,
                     username,
                     openMenuKeys,
                     onSetOpenMenuKeys,
                     dynamicSidebarChildren,
                     appLanguage,
                     nodeId,
                     nodes,
                     onFetchDynamicEntry,
                     token,
                     chosenEndpoint
                 }) => {
    const handleOnTitleClick = ({key}) => {
        let currentOpenKeys = _.clone(openMenuKeys);
        if (currentOpenKeys.includes(key)) {
            currentOpenKeys = currentOpenKeys.filter(item => item !== key)
        } else {
            currentOpenKeys.push(key);
        }
        onSetOpenMenuKeys(currentOpenKeys);
    }

    const menuProps = {};
    const subMenuProps = {};
    if (!isSidebarCollapsed) {
        menuProps.openKeys = openMenuKeys
        subMenuProps.onTitleClick = handleOnTitleClick
    }

    const [dynamicUserMenu, setDynamicUserMenu] = useState(null);

    useEffect(() => {
        if (token && chosenEndpoint && chosenEndpoint.endpoint.haveDMWS) {
            let allFetches = [];
            MenuKeysWithDynamicChildren.forEach(path => {
                const parent = userMenu(t).find(item => item.path === path);
                const dynamicChildren = parent.children.filter(child => !!child.fetchUrl);
                allFetches = allFetches.concat(dynamicChildren.map(child => ({url: child.fetchUrl(nodeId), parentPath: parent.path, childPath: child.path})))
            })
            allFetches.forEach(info => onFetchDynamicEntry(info));
        }
    }, [token, (nodes || [])]);

    useEffect(() => {
        if (dynamicSidebarChildren && dynamicSidebarChildren.length > 0) {
            setDynamicUserMenu(() => {
                const newState = userMenu(t);
                dynamicSidebarChildren.forEach(dynamicChange => {
                    const parentIdx = newState.findIndex(item => item.path === dynamicChange.parentPath);
                    if (parentIdx === -1) return;
                    const childIdx = newState[parentIdx].children.findIndex(item => item.path === dynamicChange.childPath);
                    if (childIdx === -1) return;
                    newState[parentIdx].children[childIdx].children = dynamicChange.data;
                });
                return newState;
            })
        } else {
            setDynamicUserMenu(null);
        }
    }, [dynamicSidebarChildren, appLanguage, nodeId, username])

    const subMenu = useMemo(() => [
        ...getFilteredTree(dynamicUserMenu || userMenu(t), "children", isPageVisible(permissions, anonymousPages, false)),
        ...getFilteredTree(superUserMenu(t), "children", isPageVisible(permissions, anonymousPages, false)),
    ], [dynamicUserMenu, t, permissions, anonymousPages, appLanguage]);


    return (
        isClassificationsServer(username, permissions, anonymousPages, t)
            ? null
            : (
                <Layout.Sider
                    className="sidebar"
                    width={520}
                    collapsedWidth={64}
                    theme="light"
                    collapsible
                    collapsed={propertyIsDefined(isSidebarCollapsed) ? isSidebarCollapsed : true}
                    trigger={null}>
                    <SidebarHeader/>
                    <Menu
                        className={`sidebar__menu ${(propertyIsDefined(isSidebarCollapsed) ? isSidebarCollapsed : true) ? 'sidebar__menu--collapsed' : ''}`}
                        theme="light"
                        mode="inline"
                        forceSubMenuRender
                        selectedKeys={[location.pathname]}
                        style={{
                            height: `calc(100% - ${SIDEBAR_TITLE_HEIGHT}px`,
                            overflow: "auto"
                        }}
                        {...menuProps}
                    >
                        {subMenu.map(parent =>
                            <SidebarSubMenu key={parent.path} parent={parent} subMenuProps={subMenuProps}/>)}
                    </Menu>
                </Layout.Sider>
            )
    );

}

export default compose(translate(), connect(mapStateToProps, mapDispatchToProps))(Sidebar);
